import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CommonEmptyPersonIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="user-circle" {...props} />;
};

export { CommonEmptyPersonIcon };
